
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Bushireforwedding() {



    const cardData =
    {
        keyword: 'Bus Hire For Wedding in Pune',
        heading: 'Amruta Travels: Bus Hire For Wedding in Pune',
        headingDescription: 'Amruta Travels offers Bus Hire for Wedding in Pune, ensuring a comfortable, safe, and hassle-free travel experience for your special day. Whether it is transporting guests or arranging a grand entry for the bride and groom, our well-maintained buses, including spacious 25, 32, and 50-seater options, provide a smooth and elegant ride. Enjoy punctual service, professional chauffeurs, competitive pricing, and 24/7 availability for a seamless wedding transportation solution. Book your Wedding Bus with Amruta Travels and make every moment of your celebration stylish, convenient, and stress-free!',


        top: 'Wedding Bus Hire Process with Amruta Travels',

"topPlaces": [
{
"title":"Choose Your Wedding Bus",
"description":"Select luxury, AC, or Non-AC buses in 25, 32, 35, 45, and 50-seater options based on your guest count and wedding requirements."
},
{
"title":"Share Your Wedding Schedule",
"description":"Tell us your wedding date, venues, pickup locations, guest count, and travel schedule so we can recommend the best buses."
},
{
"title":"Select Your Preferred Fleet",
"description":"Choose buses for family members, wedding guests, hotel transfers, reception events, or destination weddings according to your transportation needs."
},
{
"title":"Receive a Transparent Quotation",
"description":"Get a detailed quotation with vehicle options, pricing, reporting time, travel schedule, and payment terms without hidden charges."
},
{
"title":"Confirm Your Wedding Bus Hire",
"description":"Reserve your preferred buses early to ensure availability during the busy wedding season."
},
{
"title":"Professional Driver Allocation",
"description":"Experienced drivers are assigned to every bus, ensuring punctual reporting, safe driving, and smooth guest transportation."
},
{
"title":"Guest Pickup & Venue Transfers",
"description":"We arrange transportation between hotels, homes, airports, railway stations, marriage halls, reception venues, and parking locations."
},
{
"title":"Luxury Travel Experience",
"description":"Our clean, spacious, and well-maintained buses ensure every guest enjoys a comfortable journey throughout the wedding celebrations."
},
{
"title":"Support Throughout the Event",
"description":"Our team remains available during your wedding to coordinate transportation and handle any schedule changes whenever required."
},
{
"title":"Safe Return Transportation",
"description":"After the celebrations, we ensure guests return safely to their hotels, homes, or designated drop locations."
}
],

        "services": [
{
"name":"Luxury Wedding Bus Hire in Pune",
"description":"Hire premium luxury buses for weddings in Pune with Amruta Travels. Our luxury fleet offers spacious seating, elegant interiors, air-conditioning, and professional chauffeurs for a comfortable guest experience."
},
{
"name":"AC Wedding Bus Hire",
"description":"Book fully air-conditioned buses for wedding transportation in Pune. Perfect for summer weddings, destination weddings, and long-distance guest transfers."
},
{
"name":"Non AC Wedding Bus Hire",
"description":"Looking for an economical wedding transport solution? Our Non-AC buses provide reliable and comfortable transportation for wedding guests at affordable prices."
},
{
"name":"25 Seater Wedding Bus Hire",
"description":"Our 25-seater buses are ideal for transporting close family members, relatives, and VIP guests between hotels, marriage halls, and reception venues."
},
{
"name":"32 Seater Wedding Bus Hire",
"description":"Hire spacious 32-seater buses for medium-sized wedding groups with comfortable seating and experienced drivers."
},
{
"name":"35 Seater Wedding Bus Hire",
"description":"Book our 35-seater buses for wedding transportation across Pune with flexible pickup and drop schedules."
},
{
"name":"45 Seater Wedding Bus Hire",
"description":"Our 45-seater buses are perfect for transporting large wedding guest groups safely and comfortably."
},
{
"name":"50 Seater Wedding Bus Hire",
"description":"Choose our premium 50-seater buses for large wedding functions, receptions, and destination weddings."
},
{
"name":"Wedding Guest Transportation",
"description":"We provide complete transportation management for wedding guests with multiple pickup points and customized travel plans."
},
{
"name":"Wedding Venue Shuttle Service",
"description":"Shuttle buses between hotels, marriage halls, reception venues, and parking areas to ensure smooth guest movement."
},
{
"name":"Bride & Groom Family Transportation",
"description":"Dedicated buses for the bride's family, groom's family, and close relatives with personalized travel schedules."
},
{
"name":"Destination Wedding Bus Hire",
"description":"Planning a destination wedding near Pune? Hire our buses for Lonavala, Mahabaleshwar, Alibaug, Nashik, Shirdi, Goa, and other destinations."
}
],

        "tableData": [
    ["Luxury Wedding Bus Hire in Pune", "AC Wedding Bus Hire"],
    ["Non AC Wedding Bus Hire", "25 Seater Wedding Bus Hire"],
    ["32 Seater Wedding Bus Hire", "35 Seater Wedding Bus Hire"],
    ["45 Seater Wedding Bus Hire", "50 Seater Wedding Bus Hire"],
    ["Wedding Guest Transportation", "Wedding Venue Shuttle Service"],
    ["Bride & Groom Family Transportation", "Destination Wedding Bus Hire"],
    ["Wedding Bus Hire Near Me", "Luxury Bus Hire for Wedding"],
    ["Wedding Reception Bus Hire", "Wedding Function Bus Hire"],
    ["Hotel to Wedding Venue Bus Hire", "Wedding Shuttle Bus Service"],
    ["Outstation Wedding Bus Hire", "Premium Wedding Coach Hire"],
    ["Wedding Guest Bus Rental", "Wedding Group Transportation"],
    ["Marriage Hall Bus Hire", "Wedding Event Transportation"]
],





        "whychoose": [
{
"WhyChooseheading":"Premium Wedding Bus Fleet",
"WhyChoosedescription":"Amruta Travels maintains a fleet of luxury, AC, and Non-AC buses specially prepared for wedding transportation. Every vehicle is regularly serviced, cleaned, and inspected before every trip."
},
{
"WhyChooseheading":"Multiple Seating Capacity Options",
"WhyChoosedescription":"Whether your wedding has 25 guests or more than 500 guests, we provide 25, 32, 35, 45, and 50-seater buses to match every transportation requirement."
},
{
"WhyChooseheading":"Transportation for Every Wedding Function",
"WhyChoosedescription":"Hire buses for engagement ceremonies, Haldi, Mehendi, Sangeet, wedding day, reception, hotel transfers, and guest pickup with one trusted transportation partner."
},
{
"WhyChooseheading":"Experienced Wedding Transport Team",
"WhyChoosedescription":"Our coordinators and drivers understand wedding schedules and ensure smooth guest movement between hotels, marriage halls, reception venues, and parking areas."
},
{
"WhyChooseheading":"Customized Pickup & Drop Planning",
"WhyChoosedescription":"We create customized transportation plans with multiple pickup locations, venue transfers, return trips, and flexible schedules based on your wedding itinerary."
},
{
"WhyChooseheading":"Comfortable Journey for Every Guest",
"WhyChoosedescription":"Spacious seating, clean interiors, air-conditioning, and courteous drivers ensure your guests enjoy a safe and comfortable travel experience."
},
{
"WhyChooseheading":"Suitable for Local & Destination Weddings",
"WhyChoosedescription":"From weddings within Pune to destination weddings in Lonavala, Mahabaleshwar, Nashik, Alibaug, Goa, and nearby cities, our buses are available for every celebration."
},
{
"WhyChooseheading":"Trusted Wedding Transportation Since Years",
"WhyChoosedescription":"Thousands of families choose Amruta Travels because of our reliable buses, punctual service, experienced staff, and commitment to making wedding transportation stress-free."
}
],



















    }

    const faqData = [
        {
            question: 'How can I hire a bus for a wedding in Pune with Amruta Travels?',
            answer: 'Hiring a bus for your wedding in Pune is easy with Amruta Travels! You can book through our website, call our customer service, or visit our office for personalized assistance. We make group transportation smooth and stress-free for your big day.',
        },
        {
    question: 'What types of buses are available for wedding hire in Pune?',
    answer: 'Amruta Travels offers 25, 32, 35, 45, and 50-seater AC and Non-AC buses along with luxury coaches for wedding guest transportation, receptions, destination weddings, and family functions.',
},
        {
            question: 'Are the buses well-maintained and clean?',
            answer: 'Yes, all our buses are well-maintained, regularly serviced, and cleaned thoroughly before each trip to ensure a comfortable and hygienic experience for your guests.',
        },
        {
            question: 'Can I hire multiple buses for my wedding event in Pune?',
            answer: 'Absolutely! We can provide multiple buses based on your guest list and transportation needs. Let us know your schedule and guest count, and we’ll coordinate the fleet accordingly.',
        },
        {
            question: 'Do you offer decoration options for wedding buses?',
            answer: 'Yes, we offer basic decoration services and can also coordinate with your wedding planner for customized bus decor. Just share your theme or ideas with us during booking.',
        },
        {
            question: 'How far in advance should I book a wedding bus in Pune?',
            answer: 'We recommend booking at least 1-2 weeks in advance to ensure availability, especially during peak wedding seasons. However, we also accommodate last-minute bookings based on fleet availability.',
        },
        {
            question: 'Are your drivers experienced and familiar with wedding logistics?',
            answer: 'Yes, our drivers are experienced, well-trained, and punctual. They understand the importance of timing and coordination on wedding days and ensure smooth transport for your guests.',
        },
        {
            question: 'Do you offer pickup and drop services from multiple locations?',
            answer: 'Yes, we can arrange multiple pickups and drops as per your event schedule. Share the route and timing with us, and we’ll create a custom travel plan for your wedding guests.',
        },
        {
            question: 'Is there a fixed price for wedding bus hire in Pune?',
            answer: 'The pricing depends on the bus type, duration, distance, and any customizations. Contact us for a detailed quote with transparent pricing tailored to your wedding travel needs.',
        },
        {
            question: 'Why choose Amruta Travels for wedding bus hire in Pune?',
            answer: 'Amruta Travels provides reliable, professional, and well-organized bus hire services for weddings. With clean vehicles, courteous drivers, and attention to detail, we ensure your guests travel comfortably and on time.',
        },
    ];

    const testimonialsData = [
        {
            id: 1,
            name: 'Mrs. Anjali Deshmukh',
            role: 'Wedding Planner, Pune',
            text: 'Amruta Travels was a lifesaver during a big wedding event. The buses arrived on time, were clean and well-maintained, and the drivers were very cooperative. Our guests were transported smoothly and safely. Highly recommended!',
            rating: 5,
        },
        {
            id: 2,
            name: 'Mr. Akshay Patil',
            role: 'Groom’s Brother, Pune',
            text: 'We booked two buses with Amruta Travels for my brother’s wedding, and the experience was flawless. From pick-up coordination to guest comfort, everything was handled professionally. Thank you for making our event stress-free!',
            rating: 5,
        },
    ];





































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7353109555",
            "+91 7090597555",
            "+91 7887774499",

        ],
        email: "booking@bushireinpune.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Bus Hire For Wedding in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Buses For Corporate Events",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "25 Seater Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "32 Seater Bus Rent in Pune",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "35 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "45 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "50 Seater Bus On Rent in Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Shirdi Bus Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Bus Rentals For School Trips in Pune",
        },
        {
    place: "/images/keyword/10.jpg",
    text: "Luxury Wedding Bus Hire in Pune",
},
{
    place: "/images/keyword/11.jpg",
    text: "Wedding Guest Transportation",
},
        {
            place: "/images/keyword/12.jpg",
            text: "Bus Service for Corporate Pune",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Bus on Rent For Event in Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Bus Rental for Tour Packages",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Bus Hire for Outstation",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " AC Bus On Rent in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: " Pune Bus Hire Rental Service",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service for Picnic in Pune ",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Non Ac Bus Rental Service in Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Luxury Bus Rental in Pune",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Luxury Force Urbania On Rent in Pune ",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Bhimashankar Jyotirlinga Bus Hire in Pune ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Alibaug Bus on Rent",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune to Ganpatipule Beach Bus Rental Service ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to 5 Jyotirlinga Darshan Bus Hire",
        },
    ];


    const images = [
    { src: "/images/gallery/24.jpg", alt: "Wedding Bus Fleet - Amruta Travels Pune" },
    { src: "/images/gallery/28.jpg", alt: "Luxury Wedding Bus in Pune" },
    { src: "/images/gallery/2.jpg", alt: "Wedding Guest Transportation Bus" },
    { src: "/images/gallery/3.jpg", alt: "AC Wedding Bus Hire in Pune" },
    { src: "/images/gallery/24.jpg", alt: "Wedding Coach Bus" },
    { src: "/images/gallery/27.jpg", alt: "50 Seater Wedding Bus" },
    { src: "/images/gallery/29.jpg", alt: "Luxury Bus for Wedding Guests" },
    { src: "/images/gallery/30.jpg", alt: "Wedding Transportation Service Pune" },
    { src: "/images/gallery/31.jpg", alt: "Premium Wedding Bus Hire" },
];



const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Bus Hire For Wedding in Pune",
  "image": "https://bushireinpune.com/assets/images/bus-hire-for-wedding.jpg",
  "description": "Hire a bus for weddings in Pune with Amruta Travels. Choose from 25, 26, 32, or 50-seater AC buses for wedding functions, bride & groom travel, or shuttle services. Affordable, comfortable, and reliable wedding bus rentals in Pune and Pimpri-Chinchwad.",
  "brand": {
    "@type": "Brand",
    "name": "Amruta Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "5451"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2999",
    "availability": "https://schema.org/InStock",
    "url": "https://bushireinpune.com/bus-hire-for-wedding-pune"
  }
};







    return (
        <div>

<Helmet>
  <title>Call: +91 7353109555 | Bus Hire For Wedding in Pune | Amruta Travels</title>
  <meta 
    name="description" 
    content="Book affordable AC and luxury buses for wedding functions in Pune. Choose 25 to 50-seater buses for all marriage events with Amruta Travels. Professional, timely, and comfortable bus rental services in Pune." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section className="breadcrumb-outer text-center">
                <div className="container">
                    <div className="breadcrumb-content">
                        <h2 className="white text-center">{cardData.keyword} </h2>
                    </div>
                </div>
                <div className="overlay"></div>
            </section>





            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img
    src="/images/keyword/1.jpg"
    alt="Bus Hire For Wedding in Pune by Amruta Travels"
    loading="eager"
/>
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Amruta Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword
                                title="Testimonial"
                                description="Hear what our happy customers have to say about their travel experience with Amruta Travels."
                                reviews={testimonialsData}
                            />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #021B3A',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#021B3A' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk text-white">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917353109555" className="d-block  text-white">+91 7353109555</a>
                                                <a href="tel:+917090597555" className="d-block  text-white">+91 7090597555</a>
                                                <a href="tel:+917887774499" className="d-block  text-white">+91 7887774499</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Email</h4>
                                                <a href="mailto:booking@bushireinpune.com" className=" text-white d-block">
                                                    booking@bushireinpune.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Amruta Travels <br />
                                                        Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Bushireforwedding;